export { default as Location } from './data/location.mapper';
export { default as LocationService } from './data/location.service';
